import { Stack, Text, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { useState } from "react";
import { BsSunFill } from "react-icons/bs";
import { IoMdMoon } from "react-icons/io";
function DisplayMode() {
  const { colorMode, toggleColorMode } = useColorMode();
  const [state, setState] = useState(colorMode);
  const modeBg = useColorModeValue("#fff", "#102540");
  const modeBoxShadowBg = useColorModeValue("#cfd9e6", "#081b2e");

  const containerBg = useColorModeValue("#F0F3F7", "#030b1b");

  const xStyle = {
    bg: modeBg,
    borderRadius: "20px",

    justifyContent: "space-between",
    boxShadow: `2px 2px 5px 0px ${modeBoxShadowBg}`,
  };
  const iniStyle = {
    direction: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    p: "8px 8px",
    w: "90px",
    h: "10px",
    maxW: "90px",
    pl: "10px",
    spacing: "-10px",
    cursor: "pointer",
    spacing: "20px",
    boxSizing: "initial",
  };
  return (
    <Stack
      direction={"row"}
      alignItems="center"
      bg={containerBg}
      borderRadius={"30px"}
      p="3px 3px"
      w="195px"
      maxW="195px"
      justifyContent={"space-between"}
      border={`3px solid ${modeBg}`}
      mr={["0px", "20px"]}
    >
      <Stack
        {...(state === "light" ? xStyle : {})}
        {...iniStyle}
        onClick={() => {
          if (colorMode === "light") return;
          toggleColorMode();
          setState("light");
        }}
      >
        <BsSunFill
          color={colorMode === "dark" ? "#294c6e" : "#CFD9E6"}
          fontSize={"1.2em"}
        />
        <Text
          fontWeight={"bold"}
          color={colorMode === "dark" ? "#fff" : "#7D96B3"}
          fontSize={".6em"}
        >
          Light
        </Text>
      </Stack>
      <Stack
        {...(state === "dark" ? xStyle : {})}
        {...iniStyle}
        onClick={() => {
          if (colorMode === "dark") return;
          toggleColorMode();
          setState("dark");
        }}
      >
        <IoMdMoon
          color={colorMode === "dark" ? "#0F2A4D" : "#CFD9E6"}
          fontSize={"1.2em"}
        />
        <Text color="#7D96B3" fontSize={".6em"}>
          Dark
        </Text>
      </Stack>
    </Stack>
  );
}

export default DisplayMode;
